import { apiConfig } from "../config/config";
import { DictType } from "../types/Helper";
import { postMethod } from "../utils/apiV2";

export type ShareMessage = {
  formattedMessage: string;
  withScreenshot: boolean;
};

const serialize = (data: any) => {
  const obj: ShareMessage = {
    formattedMessage: data?.formatted_message,
    withScreenshot: data?.with_screen_shot,
  };
  return obj;
};

const getShareMessage = async (
  categoryName: string,
  section: string,
  messageParams?: DictType
) => {
  const body = {
    category_name: categoryName,
    section: section,
    message_params: messageParams,
  };

  const endPoint = `${apiConfig(
    "notificationGo"
  )}/v1/b2c/notification/get/share-message`;

  const { response, error }: any = await postMethod({
    endPoint,
    body,
  });

  if (response?.data) {
    return {
      response: serialize(response.data),
    };
  } else if (error) {
    return { error };
  }
  return null;
};

export default getShareMessage;
